// Dashboard Users retention page translations (pt-BR), loaded into dashboard.users.retention by ../pt-BR.users.js
module.exports = {
  menu: "Retenção",
  title: "Retenção",
  description: "Quantos dos utilizadores registados no período voltam depois do cadastro.",
  kpis: {
    day: "Retenção dia {n}",
  },
  info: {
    day: "Utilizadores que entraram pela primeira vez no período e voltaram à app no dia {n} ou depois.\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
  },
  hints: {
    noOldAccounts: "sem registos com {n} dias de conta",
    signupDays: "registos de {start} a {end}",
    signupDay: "registos de {start}",
  },
  day: "Dia {n}",
  panels: {
    cohorts: {
      weekly: "Coortes semanais — registos no período",
      monthly: "Coortes mensais — registos no período",
      note: "Mais verde = maior retenção. Só entram coortes iniciadas no período; “–” = ainda sem tempo suficiente.",
    },
    curve: "Curva média de retenção",
    byCohort: "Retenção {first} e {second} por coorte",
  },
  panelInfo: {
    cohorts: "Parte de cada coorte de novos utilizadores que voltou à app em cada semana ou dia depois do primeiro.\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
    curve: "Média da retenção das coortes do período em cada dia depois do primeiro.\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
    byCohort: "Retenção de cada coorte nos dois dias de referência.\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
  },
};
